import React, { useState, useEffect } from 'react';
import '../../../css/administration.css'
import '../../../components/layout/layout.css'
import BasicCard from '../../../components/basics/cards/BasicCard'
import FilterSettings from '../../../components/FilterSettings'
import Button from 'react-bootstrap/Button'
import './lspProfile.css'
import '../../../routes/basicreport/basicReport.css'
import { CommonAPIService } from "../../../services/apis/CommonAPIService";
function LspProfile({ pageTitle}) {
   

    const [updatingFilter, setUpdatingFilter] = useState(false)
  
    const [filterArray, setFilterArray] = useState(0)

    const [pageConfig, setPageConfig] = useState({
        controllerName: "LSPProfileExport",
        apiName: process.env.REACT_APP_LST_API_DOMAIN + '/api/',
        parameters: "",
    });


    const handleExportDataClick = () => {
        const filterArrayString = encodeURIComponent(JSON.stringify(filterArray));

        CommonAPIService.callApiUsingUrlReturnBlob(`${pageConfig.apiName}${pageConfig.controllerName}/Export?filterArray=${filterArrayString}`)
            .then(blob => {
            }, [pageConfig.apiName], [pageConfig.controllerName], [filterArray])
            .catch(error => console.error(error));
    };

    useEffect(() => {
        CommonAPIService.callApiUsingUrl(`${pageConfig.apiName}${pageConfig.controllerName}/PageSettings`)
            .then(data => setPageConfig({ ...pageConfig, ...{ pageSettings: data } }))
            .catch(error => console.error(error));
    }, [pageConfig.apiName, pageConfig.controllerName]);

    return (
        <BasicCard cardConfig={{ cardTitle: pageTitle, cardHeadingElement: 'h3' }}>
            <span className='basic-report-card'>
                <FilterSettings pageConfig={pageConfig} filterArray={filterArray} setFilterArray={setFilterArray} updatingFilter={updatingFilter} />               
                <BasicCard cardConfig={{ cardTitle: 'Run task', cardHeadingElement: 'h5' }}>

                <span className='brd-download-items'>
                    <Button variant='primary' onClick={handleExportDataClick}>
                        Run task
                    </Button>
                </span>
                </BasicCard>
            </span>
        </BasicCard>




    )
}

export default LspProfile